import { ImportOutlined } from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import React from 'react';

const SelfServiceIcon: React.FC<Partial<CustomIconComponentProps>> = (
  props,
) => <ImportOutlined {...props} />;

export default SelfServiceIcon;
